import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { FormationTypeEnum } from "../../constants/AppConstants";
import { OptionItem } from "../../components/TextSwitch/TextSwitch";
import { FilterProps } from "../../types/AppTypes";

export interface CoursesState {
  searchCourses: string;
  filtersCourses: FilterProps[];
  paginationCourses: number;
}

export interface CertificationsState {
  searchCertifications: string;
  filtersCertifications: FilterProps[];
  paginationCertifications: number;
}
export interface InitialStateProps {
  tabsFormation: OptionItem<FormationTypeEnum> | null;
  courses: CoursesState;
  certifications: CertificationsState;
}

export const initialState: InitialStateProps = {
  tabsFormation: null,
  courses: {
    searchCourses: "",
    filtersCourses: [],
    paginationCourses: 0,
  },
  certifications: {
    searchCertifications: "",
    filtersCertifications: [],
    paginationCertifications: 0,
  },
};

export const formationSlice = createSlice({
  name: "formations",
  initialState,
  reducers: {
    setTabsFormation: (
      state: InitialStateProps,
      action: PayloadAction<OptionItem<FormationTypeEnum>>,
    ) => {
      state.tabsFormation = action.payload;
    },
    setSearchCourses: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.courses.searchCourses = action.payload;
    },
    setFiltersCourses: (
      state: InitialStateProps,
      action: PayloadAction<FilterProps[]>,
    ) => {
      state.courses.filtersCourses = action.payload;
    },
    setPaginationCourses: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.courses.paginationCourses = action.payload;
    },
    setSearchCertification: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.certifications.searchCertifications = action.payload;
    },
    setFiltersCertification: (
      state: InitialStateProps,
      action: PayloadAction<FilterProps[]>,
    ) => {
      state.certifications.filtersCertifications = action.payload;
    },
    setPaginationCertification: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.certifications.paginationCertifications = action.payload;
    },
    resetFormationState: () => initialState,
  },
});

export const {
  setTabsFormation,
  setSearchCourses,
  setFiltersCourses,
  setPaginationCourses,
  setSearchCertification,
  setFiltersCertification,
  setPaginationCertification,
  resetFormationState,
} = formationSlice.actions;
export default formationSlice.reducer;
